import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ItemsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;

export const TextTitle = styled.p`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const ResultsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.black1};
`;

export const ScoreWrapper = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  width: 100px;
`;

export const CorrectFlashcards = styled.p`
  color: ${({ theme }) => theme.colors.green6};
`;
